import { render, staticRenderFns } from "./themes.vue?vue&type=template&id=5906156b&scoped=true&"
import script from "./themes.vue?vue&type=script&lang=js&"
export * from "./themes.vue?vue&type=script&lang=js&"
import style0 from "./themes.vue?vue&type=style&index=0&id=5906156b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5906156b",
  null
  
)

export default component.exports